import { type UserBase, userBaseFields } from './userBase';
import { type CongressBase, congressBaseFields } from './congressBase';

export interface User extends UserBase {
  congresses: CongressBase[];
}

export const userFields = `
  ${userBaseFields}
  congresses {
    ${congressBaseFields}
  }
`;
